<template>
    <div class="mb-3">
        <div class="container-fluid pt-lg-1">
            <div class="d-flex justify-content-between align-items-start">
                <!--/* Zone Fil d'ariane */-->
                <ob1-breadcrumb :items="dto.filAriane.items" style="min-width: 0" class="me-2 breadcrumb-full" />
                <div v-if="dto.digitalCartTooltipDto">
                    <div class="row justify-content-end">
                        <div class="col-auto">
                            <digital-cart-tooltip
                                :title="dto.digitalCartTooltipDto.title"
                                :content="dto.digitalCartTooltipDto.content"
                                :cta-label="dto.digitalCartTooltipDto.ctaLabel"
                                :cta-url="dto.digitalCartTooltipDto.cartPageUrl"
                                :empty-cart="dto.digitalCartTooltipDto.emptyCart"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="d-flex flex-wrap align-items-center mb-1">
                <h1 id="header-title" class="mb-0" v-html="headerTitle" />
                <div class="ms-auto col-12 col-md-4">
                    <equipment-search-field
                        v-if="searchFilters"
                        :place-holder="searchFilters.cartBannerSearchLabel"
                        :search-results-url="searchFilters.searchResultsUrl"
                        :search-results-query-additional-params="searchFilters.searchResultsQueryAdditionalParams"
                        :algolia-api-key="searchFilters.algoliaDto.apiKey"
                        :algolia-app-id="searchFilters.algoliaDto.appId"
                        :algolia-index-name="searchFilters.algoliaDto.indexName"
                        tms-category="lr-boutique-completion"
                        tms-button-action="search"
                        tms-result-action="clic-autre-compl-"
                    />
                </div>
            </div>

            <selected-offer
                v-if="dto.selectedOffer && !dto.selectedOffer.fromCart"
                class="my-1"
                :title="dto.selectedOffer.title"
                :continue-without-mobile="dto.selectedOffer.continueWithoutMobile"
                :modify-mobile-label="dto.selectedOffer.modifyMobileLabel"
                :modify-offer="dto.selectedOffer.modifyOffer"
                :offer-label="dto.selectedOffer.offerLabel"
            />

            <div class="d-webview-none">
                <contract-phone-lines
                    v-if="dto.contractInfos"
                    class="mb-md-1 my-lg-1"
                    :contract-infos="dto.contractInfos"
                />
            </div>
            <incentive
                v-if="dto.incentiveDto"
                :title="dto.incentiveDto.question"
                :text="dto.incentiveDto.message"
                :link-href="dto.changerMobileLink"
                :link-label="dto.incentiveDto.linkLabel"
            />
            <intention-switch
                v-if="dto.intentionSwitchDto"
                :shop-sosh="brand === 'SOSH'"
                :title="dto.intentionSwitchDto.title"
                :acquisition-label="dto.intentionSwitchDto.acquisitionLabel"
                :tseul-label="dto.intentionSwitchDto.tseulLabel"
                :changer-de-mobile-label="dto.intentionSwitchDto.changerDeMobileLabel"
                :default-intention-checked="intentionParam"
                :linked-with-results="true"
                @switch-intention="switchIntention($event)"
            />
            <template v-if="dto.customerPopin">
                <customer-popin
                    id="customer-popin-id"
                    :title="dto.customerPopin.customerPopinLabelsDto.title"
                    :subtitle="dto.customerPopin.customerPopinLabelsDto.subtitle"
                    :text="dto.customerPopin.customerPopinLabelsDto.text"
                    :button-label="dto.customerPopin.customerPopinLabelsDto.buttonLabel"
                    :button-link="dto.customerPopin.customerPopinLinksDto.buttonLink"
                    :link-label-html="dto.customerPopin.customerPopinLabelsDto.linkLabelHtml"
                    :link="dto.customerPopin.customerPopinLinksDto.link"
                    :intention="dto.customerPopin.intention"
                />
            </template>

            <template v-if="showDeviceSpinner && displaySkeletonPersoReco">
                <skeleton-reco-mobiles-card :with-subtitle="true" />
            </template>
            <template v-if="displayRecoMobiles">
                <reco-mobiles
                    :mobiles="reco.mobiles"
                    :title="reco.title"
                    :sub-title="reco.subTitle"
                    :shop="brand"
                    :advantage-messages="advantageMessages"
                    :data-pdb-zid="dataPdbZid"
                    :funding-details-dto="fundingDetails"
                    :enable-price-inversion="enablePriceInversion"
                    :show-sold-by-infos="dto.showSoldByInfos"
                    :has-third-parties-in-cart="hasThirdPartiesInCart"
                    @fundingDetailsClick="handleRecoMobilesFundingDetailsClick"
                    @energyLabelClick="handleRecoMobilesEnergyLabelClick"
                />
            </template>

            <div class="row">
                <!--/* Filtre partie Desktop */-->
                <section aria-label="Filtres des produits" class="col-12 col-xl-4 col-xxl-3 filters-sidebar d-none d-xl-block border-end border-gray4">
                    <bouton
                        label="Sauter les filtres et atteindre les résultats"
                        :is-primary="false"
                        class="visually-hidden-focusable"
                        @click="skipFilters()"
                    />
                    <h2 id="filters-title-desktop" class="visually-hidden">
                        Filtrer par
                    </h2>
                    <div ref="filtersDesktopTarget" />
                </section>

                <!--/*  Les deux boutons tri et filtre mode Mobile et Tablette */-->
                <div class="col-12 d-xl-none d-flex gap-md-1 w-100 mb-1 px-0 px-md-1 border-bottom-md-none border-bottom border-gray4">
                    <div
                        class="flex-fill flex-basis-0 bg-gray2 d-flex justify-content-center align-items-center padding-button border-end-md-none border-end border-gray4"
                    >
                        <h2 id="sort-title" class="visually-hidden">
                            Trier par
                        </h2>
                        <ob1-liens-icone
                            is-button
                            modal-id="sort-modal"
                            title="Trier"
                            data-bs-toggle="modal"
                            icon="icon-filter"
                            type="button"
                        />
                    </div>
                    <div
                        class="flex-fill flex-basis-0 bg-gray2 d-flex justify-content-center align-items-center padding-button"
                    >
                        <ob1-liens-icone
                            is-button
                            modal-id="filters-modal"
                            title="Filtrer"
                            class="ms-1"
                            data-bs-toggle="modal"
                            icon="icon-configuration-contrat"
                            type="button"
                        />
                    </div>
                </div>

                <div class="col-12 col-xl-8 col-xxl-9 main-content-sidebar">
                    <div class="mb-1 mt-xl-1">
                        <div class="d-flex">
                            <div
                                id="total-devices"
                                class="pe-1"
                                style="white-space: nowrap;"
                            >
                                <p class="font-size-16 lead fw-bold mb-0 me-1">
                                    <span class="aria-hidden">{{ resultsLabel }}</span>
                                    <output
                                        id="results-number-accessible"
                                        class="visually-hidden"
                                    >
                                        {{ filtersAndSortAccessibleLabel }}
                                    </output>
                                </p>
                            </div>
                            <div
                                class="chips-filters d-flex ps-1 flex-xl-wrap flex-nowrap overflow-x-auto position-relative"
                                :class="numberOfSelectedFilters > 0 ? 'border-start border-gray3 flex-fill' : 'flex-fill'"
                            >
                                <ob1-input-chips
                                    v-if="firstPartyOnly"
                                    id="chip-firstPartyOnly"
                                    additional-classes="mb-1 me-1"
                                    :label="dto.brand === 'ORANGE' ? 'Vendu par Orange' : 'Vendu par Sosh'"
                                    @ob1-input-chips-click="toggleFirstPartyOnly(true)"
                                />
                                <ob1-input-chips
                                    v-for="selectedSelector in selectedSelectorsCheckboxes"
                                    :id="'chip-' + selectedSelector.id"
                                    :key="selectedSelector.name"
                                    additional-classes="mb-1 me-1"
                                    :label="selectedSelector.name"
                                    @ob1-input-chips-click="toggleSelector(selectedSelector.id, false, true)"
                                />
                                <ob1-input-chips
                                    v-for="selectedBrand in selectedBrandsCheckboxes"
                                    :id="'chip-' + selectedBrand.id"
                                    :key="selectedBrand.name"
                                    additional-classes="mb-1 me-1"
                                    :label="selectedBrand.name"
                                    @ob1-input-chips-click="toggleBrand(selectedBrand.id, false, true)"
                                />
                                <ob1-input-chips
                                    v-for="selectedPrice in selectedPricesCheckboxes"
                                    :id="'chip-' + selectedPrice.id"
                                    :key="selectedPrice.name"
                                    additional-classes="mb-1 me-1"
                                    :label="selectedPrice.name"
                                    @ob1-input-chips-click="togglePrice(selectedPrice.id, false, true)"
                                />
                                <ob1-input-chips
                                    v-for="selectedNote in selectedNotesCheckboxes"
                                    :id="'chip-' + selectedNote.id"
                                    :key="selectedNote.name"
                                    additional-classes="mb-1 me-1"
                                    :label="selectedNote.name"
                                    @ob1-input-chips-click="toggleNote(selectedNote.id, false, true)"
                                />
                                <ob1-input-chips
                                    v-for="statusChip in selectedStatusCheckboxes"
                                    :id="'chip-' + statusChip.id"
                                    :key="statusChip.name"
                                    additional-classes="mb-1 me-1"
                                    :label="statusChip.name"
                                    @ob1-input-chips-click="toggleStatus(statusChip.id, false, true)"
                                />
                                <ob1-input-chips
                                    v-for="compatibilityChip in selectedCompatibilityCheckboxes"
                                    :id="'chip-' + compatibilityChip.id"
                                    :key="compatibilityChip.name"
                                    additional-classes="mb-1 me-1"
                                    :label="compatibilityChip.name"
                                    @ob1-input-chips-click="toggleCompatibility(compatibilityChip.id, false, true)"
                                />
                                <ob1-input-chips
                                    v-for="selectedBonus in selectedBonusRangesCheckboxes"
                                    :id="'chip-' + selectedBonus.id"
                                    :key="selectedBonus.name"
                                    additional-classes="mb-1 me-1"
                                    :label="selectedBonus.name"
                                    @ob1-input-chips-click="toggleBonusRanges(selectedBonus.id, false, true)"
                                />
                                <ob1-liens-icone
                                    v-if="numberOfSelectedFilters > 0"
                                    is-button
                                    title="Tout effacer"
                                    class="mb-1 py-0 flex-shrink-0"
                                    icon="icon-trash"
                                    type="button"
                                    @click="onDeleteSelectionClick"
                                />
                            </div>

                            <ob1-drop-down
                                id="mobile-sortBy-desktop"
                                :is-button="true"
                                class="ms-3 d-none d-xl-block flex-shrink-0"
                                :drop-down-dto="dto.dropDownDto"
                                @ob1-drop-item-click="sortDevices"
                            />
                        </div>
                        <!--/* Tri Mobile et Tablette*/-->
                        <div class="slide-popin-modal d-xl-none">
                            <slide-popin-modal-filter
                                id="sort-modal"
                                aria-labelledby="sort-title"
                                :button-label="'Valider la selection'"
                            >
                                <device-sort
                                    :sort-radio-buttons="sortRadioButtons"
                                    @sort-item-click="sortDevices"
                                />
                            </slide-popin-modal-filter>
                        </div>
                        <!--/* Filtre partie Mobile et Tablette*/-->
                        <div class="slide-popin-modal d-xl-none">
                            <slide-popin-modal-filter
                                id="filters-modal"
                                aria-labelledby="filters-title"
                                :delete-selection-label="deleteSelectionLabel"
                                :number-of-selected-filters="numberOfSelectedFilters"
                                :button-label="dto.filtersButtonLabel"
                                @delete-selection-click="onDeleteSelectionClick"
                            >
                                <h2 id="filters-title" class="visually-hidden">
                                    Filtrer par
                                </h2>
                                <div ref="filtersMobileTarget" />
                            </slide-popin-modal-filter>
                        </div>
                        <!--/*  Composant Filtre unique (sera déplacé selon mobile, tablette ou desktop) */-->
                        <div ref="filtersWrapper" style="display: contents;">
                            <device-list-filters
                                :first-party-only-checked="firstPartyOnly"
                                :brand-checkboxes="brandCheckboxes"
                                :price-checkboxes="priceCheckboxes"
                                :note-checkboxes="noteCheckboxes"
                                :selector-groups-checkboxes="selectorGroupsCheckboxes"
                                :status-checkboxes="statusCheckboxes"
                                :compatibility-checkboxes="compatibilityCheckboxes"
                                :bonus-ranges-checkboxes="bonusRangesCheckboxes"
                                :brand-search-label="dto.filters.brandSearchLabel"
                                :brand-search-value="brandSearchValue"
                                :collapsed-brands-label="dto.filters.collapsedBrandsLabel"
                                :not-collapsed-brands-label="dto.filters.notCollapsedBrandsLabel"
                                :results-accessible-label="filtersAndSortAccessibleLabel"
                                :first-party-only="dto.firstPartyOnly"
                                :shop-brand="brand"
                                @toggle-first-party-only-filter="toggleFirstPartyOnly"
                                @update-brand-search-value="updateBrandSearchValue"
                                @toggle-brand-filter="toggleBrand"
                                @toggle-price-filter="togglePrice"
                                @toggle-note-filter="toggleNote"
                                @toggle-selector-filter="toggleSelector"
                                @toggle-status-filter="toggleStatus"
                                @toggle-compatibility-filter="toggleCompatibility"
                                @toggle-bonus-filter="toggleBonusRanges"
                            />
                        </div>
                    </div>

                    <section aria-label="Liste des produits">
                        <div class="row">
                            <article
                                v-for="(item, index) in selectorCards"
                                id="productsList"
                                :key="index"
                                class="col-12 col-md-6 col-xxl-4 selector-accessory-card mb-1 d-flex flex-column"
                            >
                                <!--/* Tuile animation PXF */-->
                                <template v-if="item.type === 'pxf'">
                                    <pxf-animation-card
                                        :is-orange="brand === 'ORANGE'"
                                        :title="pxfAnimation.title"
                                        :sub-title="pxfAnimation.subTitle"
                                        :text="pxfAnimation.text"
                                        :url-access-wording="pxfAnimation.urlAccessWording"
                                        :url="pxfAnimation.url"
                                        :visual="pxfAnimation.visual"
                                    />
                                </template>

                                <!--/* Tuile animation reconditionnés */-->
                                <template v-else-if="item.type === 'refurbishment'">
                                    <selector-animation
                                        :title="refurbishmentAnimation.title"
                                        :title-for-tag="refurbishmentAnimation.titleForTag"
                                        :text="refurbishmentAnimation.text"
                                        :url-access-wording="refurbishmentAnimation.urlAccessWording"
                                        :url="refurbishmentAnimationUrl"
                                        :visual="refurbishmentAnimation.visual"
                                    />
                                </template>

                                <!--/* Tuile produit */-->
                                <template v-else>
                                    <device-card
                                        :device="item"
                                        :advantage-messages="dto.advantageMessages"
                                        :has-third-parties-in-cart="hasThirdPartiesInCart"
                                        :funding-details="dto.fundingDetails"
                                        :show-sold-by-infos="dto.showSoldByInfos"
                                        :enable-price-inversion="enablePriceInversion"
                                        :device-in-cart-seo-id="dto.deviceInCartSeoId"
                                        :index="index"
                                        @fundingDetailsClick="handleFundingDetailsClick"
                                        @energyLabelClick="handleEnergyLabelClick"
                                    />
                                </template>
                            </article>
                        </div>
                        <div v-if="showDeviceSpinner" class="d-flex justify-content-center">
                            <ob1-progress-indicators type="undetermined" :size="50" />
                        </div>
                        <div class="d-flex flex-column align-items-center py-2">
                            <bouton
                                v-if="showMoreDevicesButton"
                                id="showMoreButton"
                                label="Voir plus de mobiles"
                                :is-primary="false"
                                class="mx-0 my-1"
                                :is-disabled="showDeviceSpinner"
                                @click="getMoreDevices()"
                            />
                            <bouton
                                label="Revenir aux filtres pour affiner la recherche"
                                :is-primary="false"
                                class="visually-hidden-focusable d-xl-none"
                                data-bs-toggle="modal"
                                data-bs-target="#filters-modal"
                                aria-controls="filters-modal"
                            />
                            <bouton
                                label="Revenir aux filtres pour affiner la recherche"
                                :is-primary="false"
                                class="visually-hidden-focusable d-none d-xl-block"
                                @click="goToFilters"
                            />
                        </div>
                    </section>
                </div>
            </div>
        </div>

        <div v-if="editorialTitle && editorialDescription" class="container-fluid mt-2">
            <h2>{{ editorialTitle }}</h2>
            <p class="text-mw" v-html="editorialDescription" />
        </div>

        <div v-if="displayAdditionalInfo" class="bg-gray2 mt-2">
            <div class="container-fluid pt-1">
                <p
                    v-if="pxfEnabled && dto.legalMentions.pxfMention"
                    class="fw-bold mb-0"
                    v-html="dto.legalMentions.pxfMention"
                />
                <legal-mentions4x-cb
                    v-if="cb4xEnabled && dto.legalMentions.cb4xMention"
                    :label="dto.legalMentions.cb4xMention"
                    :popin4x-cb="dto.legalMentions.popin4xCb"
                />
                <free-hands v-if="freeHandsLabel" :text="freeHandsLabel" />
            </div>
        </div>
        <!-- Popin de financement-->
        <pxf-cb4x-modal
            v-if="selectedFundingDetailVersion"
            modal-id="funding-details-popin"
            :display-cb4x="selectedFundingDetailVersion.cb4xAvailable"
            :display-pxf="selectedFundingDetailVersion.pxfAvailable"
        >
            <template v-if="selectedFundingDetailVersion.cb4xAvailable" #cb4x-content>
                <!-- 4xCB payant  -->
                <paying-detail-cb4x-modal-content
                    v-if="dto.fundingDetails.cb4xPopin.withFees"
                    modal-id="funding-details-popin"
                    :oney-merchant-guid="dto.fundingDetails.cb4xPopin.oneyMerchantGuid"
                    :oney-widget-src="dto.fundingDetails.oneyWidgetSrc"
                    :counter-delay="dto.fundingDetails.counterDelay"
                    :amount="selectedFundingDetailVersion.discountedPriceInCents / 100"
                    :header-block="dto.fundingDetails.cb4xPopin.headerBlock"
                    :how-to-benefit="dto.fundingDetails.cb4xPopin.howToBenefit"
                    :cgu="dto.fundingDetails.cb4xPopin.cgu"
                    :illustration="dto.fundingDetails.cb4xPopin.imageZen"
                />
                <!-- 4xCB gratuit avec détail du prix  -->
                <cb4x-modal-content
                    v-else-if="selectedFundingDetailVersion.spreadingPrice4xCbWithoutFees"
                    :header-block="dto.fundingDetails.cb4xPopin.headerBlock"
                    :payment-block="dto.fundingDetails.cb4xPopin.paymentBlock"
                    :payment-simulation-block="dto.fundingDetails.cb4xPopin.paymentSimulationBlock"
                    :how-to-benefit="dto.fundingDetails.cb4xPopin.howToBenefit"
                    :faq="dto.fundingDetails.cb4xPopin.faqBlock"
                    :cgu="dto.fundingDetails.cb4xPopin.cgu"
                    :monthly-price="selectedFundingDetailVersion.spreadingPrice4xCbWithoutFees.monthlyPrice"
                    :first-monthly-price="selectedFundingDetailVersion.spreadingPrice4xCbWithoutFees.firstMonthlyPrice"
                    :one-shot-price="selectedFundingDetailVersion.spreadingPrice4xCbWithoutFees.oneShotPrice"
                    :illustration="dto.fundingDetails.cb4xPopin.imageZen"
                />
            </template>
            <!-- Payez en 12x, 24x, 36x ou 48x  -->
            <template v-if="selectedFundingDetailVersion.pxfAvailable" #pxf-content>
                <pxf-modal-content
                    :header-block-dto="dto.fundingDetails.pxfPopin.headerBlockDto"
                    :example-pxf-data="dto.fundingDetails.pxfPopin.examplePxfData"
                    :example-pxf-tab-subtitle="dto.fundingDetails.pxfPopin.examplePxfTabSubtitle"
                    :example-pxf-tab-title="dto.fundingDetails.pxfPopin.examplePxfTabTitle"
                    :version-pxf-data="selectedFundingDetailVersion.versionPxfData"
                    :version-pxf-tab-title="dto.fundingDetails.pxfPopin.versionPxfTabTitle"
                    :pxf-legal-mentions-text="dto.fundingDetails.pxfPopin.pxfLegalMentionsText"
                    :illustration="dto.fundingDetails.pxfPopin.imageZen"
                    :financing-block="dto.fundingDetails.pxfPopin.financingBlock"
                    :cgu="dto.fundingDetails.pxfPopin.cguDto"
                    :how-to-benefit-dto="dto.fundingDetails.pxfPopin.howToBenefitDto"
                />
            </template>
        </pxf-cb4x-modal>
        <!-- Popin étiquette énergie (unique, alimentée par les tuiles) -->
        <energy-label-popin
            v-if="selectedEnergyLabel"
            :energy-label="selectedEnergyLabel"
            modal-id="energy-label-popin"
        />
    </div>
</template>

<script>
import Cb4xModalContent from "../common/components/Cb4xModalContent.vue";
import ContractPhoneLines from "../common/ContractPhoneLines.vue";
import CustomerPopin from "../common/components/CustomerPopin.vue";
import DeviceListFilters from "./components/DeviceListFilters.vue";
import Incentive from "../common/components/Incentive.vue";
import IntentionSwitch from "../common/components/IntentionSwitch.vue";
import LegalMentions4xCb from "../common/components/LegalMentions4xCb.vue";
import PayingDetailCb4xModalContent from "../common/components/PayingDetailCb4xModalContent.vue";
import PxfCb4xModal from "../common/components/PxfCb4xModal.vue";
import PxfModalContent from "../common/components/PxfModalContent.vue";
import SlidePopinModalFilter from "../common/selector/fragment/SlidePopinModalFilter.vue";
import Bouton from "../../common/components/ob1/Bouton.vue";
import DeviceSort from "./components/DeviceSort.vue";
import DeviceCard from "./components/DeviceCard.vue";
import {toTmsFormat} from "../../common/utils/TmsUtils";
import PxfAnimationCard from "../common/selector/fragment/PxfAnimationCard.vue";
import SelectorAnimation from "../common/selector/fragment/SelectorAnimation.vue";
import FreeHands from "../../common/components/FreeHands.vue";
import DigitalCartTooltip from "../../common/components/vue/tooltip/DigitalCartTooltip.vue";
import RecoMobiles from "./components/RecoMobiles.vue";
import SelectedOffer from "../common/SelectedOffer.vue";
import {scrollToElement} from "../common/Util";
import SkeletonRecoMobilesCard from "../common/selector/fragment/SkeletonRecoMobilesCard.vue";
import EnergyLabelPopin from "../common/EnergyLabelPopin.vue";
import EquipmentSearchField from "../common/fragments/EquipmentSearchField.vue";

const dto = JSON.parse(document.getElementById("device-phone-list").dataset.devicePhoneList);
const headerTitle = JSON.parse(document.getElementById("device-phone-list").dataset.headerTitle);


const pageParam = 'page';
const sortParam = 'sort';
const orangeOnlyParam = 'orangeOnly';
const soshOnlyParam = 'soshOnly';
const brandsParam = 'brands';
const pricesParam = 'prices';
const notesParam = 'notes';
const selectorsParam = 'selectors';
const segmentParam = 'segment';
const intentionParam = 'intention';
const disuParam = 'disu';
const statusParam = 'status';
const offerParam = 'offer';
const compatibilityParam = 'compatibility';
const bonusRangesParam = 'bonusRanges';

const ACQUISITION_PARAM = "acquisition";
const CHANGER_DE_MOBILE_PARAM = "changer-de-mobile";
const PCM_PARAM = "pcm";
const PCMOA_PARAM = "pcmoa";
const RENOUVELLEMENT_PARAM = "renouvellement";
const TSEUL_PARAM = "terminal-seul";

//Méthode utilisée dans data() donc le this pas instancié encore
function syncAppleIphone(brands, brandCheckboxes = null) {
    const hasApple = brands.some(b => b.toLowerCase() === "apple")
    const hasIphone = brands.some(b => b.toLowerCase() === "iphone")

    if (hasApple && !hasIphone) {
        const iphoneCheckbox = brandCheckboxes ? brandCheckboxes.find(b => b.name.toLowerCase === "iphone") : null;
        if (!brandCheckboxes || (iphoneCheckbox && !iphoneCheckbox.disabled)) {
            return [...brands, "iphone"];
        }
    }
    if (hasIphone && !hasApple) {
        const appleCheckbox = brandCheckboxes ? brandCheckboxes.find(b => b.name.toLowerCase === "apple") : null;
        if (!brandCheckboxes || (appleCheckbox && !appleCheckbox.disabled)) {
            return [...brands, "apple"];
        }
    }
    return brands;
}

export default {
    name: "DevicePhoneList",
    components: {
        EquipmentSearchField,
        SelectedOffer,
        DigitalCartTooltip,
        FreeHands,
        SelectorAnimation,
        PxfAnimationCard,
        DeviceCard,
        DeviceSort,
        Bouton,
        Cb4xModalContent,
        ContractPhoneLines,
        CustomerPopin,
        DeviceListFilters,
        Incentive,
        IntentionSwitch,
        LegalMentions4xCb,
        PayingDetailCb4xModalContent,
        PxfModalContent,
        PxfCb4xModal,
        RecoMobiles,
        SkeletonRecoMobilesCard,
        SlidePopinModalFilter,
        EnergyLabelPopin,
    },
    data() {
        const urlParams = new URLSearchParams(window.location.search);
        const orangeOnlyFromUrl = urlParams.get(orangeOnlyParam) === 'true';
        const soshOnlyFromUrl = urlParams.get(soshOnlyParam) === 'true';
        const pageFromUrl = urlParams.get(pageParam) ?? 1;
        const sortFromUrl = urlParams.get(sortParam);
        const brandsFromUrl = urlParams.get(brandsParam);
        const pricesFromUrl = urlParams.get(pricesParam);
        const notesFromUrl = urlParams.get(notesParam);
        const selectorsFromUrl = urlParams.get(selectorsParam);
        const intentionFromUrl = urlParams.get(intentionParam);
        const disuFromParam = urlParams.get(disuParam);
        const disuFromUrl = disuFromParam !== null ? disuFromParam === 'true' : null;
        const statusFromUrl = urlParams.get(statusParam);
        const offerFromUrl = urlParams.get(offerParam);
        const compatibilityFromUrl = urlParams.get(compatibilityParam);
        const bonusRangesFromUrl = urlParams.get(bonusRangesParam);

        //On regarde si on a un Apple ou Iphone dans l'url pour Ajouter Apple à Iphone et vise-versa
        const rawBrands = brandsFromUrl ? brandsFromUrl.split(",") : [];
        let normalizedBrands = syncAppleIphone(rawBrands);
        const needsBrandUrlNormalization = rawBrands.length !== normalizedBrands.length;

        const selectorGroupsCheckboxes = this.getSelectorGroupsCheckboxes(
            dto.filters,
            dto.segmentSeoId,
            selectorsFromUrl ? selectorsFromUrl.split(",") : []
        );
        const {editorialTitle, editorialDescription} = this.getEditorialFromSelectors(selectorGroupsCheckboxes);

        return {
            dto: dto,
            numberOfResults: dto.deviceList.numberOfResults ?? null,
            devices: dto.deviceList.devices,
            brandSearchValue: '',
            brandCheckboxes: this.getBrandCheckboxes(dto.filters, normalizedBrands),
            priceCheckboxes: this.getPriceCheckboxes(dto.filters, pricesFromUrl ? pricesFromUrl.split(",") : []),
            noteCheckboxes: this.getNoteCheckboxes(dto.filters, notesFromUrl ? notesFromUrl.split(",") : []),
            selectorGroupsCheckboxes: selectorGroupsCheckboxes,
            statusCheckboxes: this.getStatusCheckboxes(dto.filters, statusFromUrl ? statusFromUrl.split(",") : []),
            compatibilityCheckboxes: this.getCompatibilityCheckboxes(dto.filters, compatibilityFromUrl ? compatibilityFromUrl.split(",") : []),
            bonusRangesCheckboxes: this.getBonusRangesCheckboxes(dto.filters, bonusRangesFromUrl ? bonusRangesFromUrl.split(",") : []),
            segment: dto.segmentSeoId,
            selectedFundingDetailVersion: undefined,
            selectedEnergyLabel: undefined,
            apiRootUrl: dto.apiRootUrl,
            currentPage: Number(pageFromUrl),
            firstPartyOnly: dto.brand === 'ORANGE' ? orangeOnlyFromUrl : soshOnlyFromUrl,
            recoForAcquisition: null,
            recoForPcm: null,
            recoForRenouvellement: null,
            recoForTSeul: null,
            showDeviceSpinner: false,
            sort: sortFromUrl ?? "par-defaut",
            hasMoreDevices: dto.deviceList.hasMoreDevices,
            filtersAndSortAccessibleLabel: undefined,
            isMobile: window.matchMedia("(max-width: " + (myshop.ob1.breakpoints.xl - 1) + "px)").matches,
            brand: dto.brand,
            intentionParam: dto.defaultIntention,
            selectedOffer: undefined,
            currentDepartmentSeoId: dto.smartphonesDepartmentSeoId,
            advantageMessages: dto.advantageMessages,
            displaySkeletonPersoReco: dto.displaySkeletonPersoReco,
            dataPdbZid: dto.brand === 'ORANGE' ? 'shop-digital_selecteur-produit_client_zone-reco-tuile_' : 'shop-digital-sosh_selecteur-produit_client_zone-reco-tuile_',
            fundingDetails: dto.fundingDetails,
            pxfAnimation: dto.pxfAnimation,
            refurbishmentAnimation: dto.refurbishmentAnimation,
            refurbishmentAnimationUrl: '',
            pxfEnabled: dto.deviceList.pxfEnabled,
            cb4xEnabled: dto.deviceList.cb4xEnabled,
            enablePriceInversion: dto.deviceList.priceInversionEnabled,
            freeHandsLabel: dto.freeHandsLabel,
            displayCustomerPopin: intentionFromUrl === CHANGER_DE_MOBILE_PARAM && dto.customerPopin,
            needsBrandUrlNormalization: needsBrandUrlNormalization,
            headerTitle: headerTitle,
            disu: disuFromUrl,
            status: statusFromUrl,
            searchFilters: dto.searchFilters,
            offerFromCart: dto.deviceSeoIdFromCart !== null && offerFromUrl === null,
            editorialTitle: editorialTitle,
            editorialDescription: editorialDescription,
        };
    },
    computed: {
        numberOfSelectedFilters: function () {
            let totalFilters = 0;
            if (this.firstPartyOnly) {
                totalFilters++;
            }
            totalFilters += this.selectedBrands.length;
            totalFilters += this.selectedPrices.length;
            totalFilters += this.selectedNotes.length;
            totalFilters += this.selectedSelectors.length;
            totalFilters += this.selectedStatus.length;
            totalFilters += this.selectedCompatibilities.length;
            totalFilters += this.selectedBonusRanges.length;
            return totalFilters;
        },
        hasNoFilters() {
            return this.numberOfSelectedFilters === 0;
        },
        displayRecoMobiles() {
            return this.devices.length > 0 && !this.showDeviceSpinner && this.hasNoFilters && this.reco && this.reco.mobiles.length > 0;
        },
        reco() {
            switch(this.intentionParam) {
                case ACQUISITION_PARAM:
                    return this.recoForAcquisition;
                case PCM_PARAM:
                    return this.recoForPcm;
                case RENOUVELLEMENT_PARAM:
                    return this.recoForRenouvellement;
                case TSEUL_PARAM:
                    return this.recoForTSeul;
            }
            return null;
        },
        deleteSelectionLabel: function () {
            return this.dto.deleteFiltersLabel + ' (' + this.numberOfSelectedFilters + ')'
        },
        showMoreDevicesButton() {
            return this.hasMoreDevices;
        },
        selectedBrandsCheckboxes() {
            return this.brandCheckboxes
                .filter(checkbox => checkbox.isChecked);
        },
        selectedPricesCheckboxes() {
            return this.priceCheckboxes
                .filter(checkbox => checkbox.isChecked);
        },
        selectedNotesCheckboxes() {
            return this.noteCheckboxes
                .filter(checkbox => checkbox.isChecked);
        },
        selectedSelectorsCheckboxes() {
            return this.selectorGroupsCheckboxes.flatMap (group => group.selectors)
                .filter(checkbox => checkbox.isChecked);
        },
        selectedStatusCheckboxes() {
            return this.statusCheckboxes
                .filter(checkbox => checkbox.isChecked);
        },
        selectedCompatibilityCheckboxes() {
            return this.compatibilityCheckboxes
                .filter(checkbox => checkbox.isChecked);
        },
        selectedBonusRangesCheckboxes() {
            return this.bonusRangesCheckboxes
                .filter(checkbox => checkbox.isChecked);
        },
        selectedBrands() {
            return this.selectedBrandsCheckboxes.map(checkbox => checkbox.name);
        },
        encodedSelectedBrandsParam() {
            return this.selectedBrands.map(brand => encodeURIComponent(brand)).join(',');
        },
        selectedPrices() {
            return this.selectedPricesCheckboxes.map(checkbox => checkbox.value);
        },
        selectedNotes() {
            return this.selectedNotesCheckboxes.map(checkbox => checkbox.value);
        },
        selectedSelectors() {
            return this.selectedSelectorsCheckboxes.map(checkbox => checkbox.value);
        },
        selectedStatus() {
            return this.selectedStatusCheckboxes.map(checkbox => checkbox.value);
        },
        selectedCompatibilities() {
            return this.selectedCompatibilityCheckboxes.map(checkbox => checkbox.value);
        },
        selectedBonusRanges() {
            return this.selectedBonusRangesCheckboxes.map(checkbox => checkbox.value);
        },
        sortRadioButtons() {
            const sortOptions = [
                { id: "par-defaut", value: "", ariaLabelledBy: "pertinence", primaryText: "pertinence" },
                { id: "par-prix-asc", value: "par-prix-asc", ariaLabelledBy: "prix-croissant", primaryText: "prix croissant" },
                { id: "par-prix-desc", value: "par-prix-desc", ariaLabelledBy: "prix-decroissant", primaryText: "prix décroissant" }
            ];

            return sortOptions.map(option => ({
                radioButtonDTO: {
                    id: option.id,
                    name: "tri",
                    label: "",
                    checked: this.sort === option.id,
                    ariaLabelledBy: option.ariaLabelledBy,
                    value: option.value
                },
                primaryText: option.primaryText
            }));
        },
        selectorCards() {
            const items = [...this.devices];
            if (this.devices.length > 0 && this.displayPxfAnimation) {
                items.splice(0, 0, { type: 'pxf' });
            }
            if (this.devices.length > 0 && this.refurbishmentAnimation) {
                items.splice(4, 0, { type: 'refurbishment' });
            }
            return items;
        },
        displayPxfAnimation() {
            return this.pxfEnabled && this.devices.some(device => device.firstParty);
        },
        hasThirdPartiesInCart() {
            return this.dto.cart?.hasThirdParties;
        },
        resultsLabel() {
            if (this.numberOfResults) return this.numberOfResults + (this.numberOfResults <= 1 ? ' résultat' : ' résultats');
            else return 'Résultats';
        },
        displayAdditionalInfo() {
            return (
                (this.pxfEnabled && this.dto.legalMentions.pxfMention) ||
                (this.cb4xEnabled && this.dto.legalMentions.cb4xMention) ||
                this.freeHandsLabel
            );
        }
    },
    created: function () {
    },
    mounted() {
        jQuery(document).ready(()  => {
            // Permet de déplacer le composant des filtres dans la bonne cible (mobile ou desktop)
            this.mediaQuery = window.matchMedia("(max-width: " + (myshop.ob1.breakpoints.xl - 1) + "px)");
            this.mediaQuery.addEventListener('change', this.handleBreakpointChange);
            this.moveFiltersToTarget();
            //On change l'url sauf si on a ajouté Apple à Iphone et vise-versa
            if (this.needsBrandUrlNormalization) {
                this.updateCurrentUrl();
            }

            this.updateLayout();

            window.addEventListener("resize", () => {
                this.updateLayout();

                // Fermer les modals trir et filtre si on passe de mobile à desktop avec popin ouverte
                if (window.matchMedia("(min-width: " + myshop.ob1.breakpoints.xl + "px)").matches) {
                    $('#filters-modal').modal('hide');
                    $('#sort-modal').modal('hide');
                }
            });
            this.filtersAndSortAccessibleLabel = this.getFiltersAndSortLabel();

            $('#filters-modal').on('hide.bs.modal', event => {
                $('#results-number-accessible').attr("role", "status")
            });
            $('#filters-modal').on('show.bs.modal', event => {
                $('#results-number-accessible').attr("role", "off")
            });

            // Gestion de la popin utilisateur
            const customerPopin = $('#customer-popin-id');
            customerPopin.on('hide.bs.modal', () => {
                this.intentionParam = ACQUISITION_PARAM;
                this.updatePageUrlWithIntention();
            });
            if (this.displayCustomerPopin) {
                customerPopin.modal('show');
            }
            this.updateReco(this.dto.deviceList.reco);
        })

    },
    updated() {
        this.$nextTick(function () {
            this.updateLayout();
            if (this.refurbishmentAnimation?.url) {
                this.updateRefurbishmentAnimationUrl(this.refurbishmentAnimation.url);
            }
        })
    },
    beforeDestroy() {
        if (this.mediaQuery) {
            this.mediaQuery.removeEventListener('change', this.handleBreakpointChange);
        }
    },
    methods: {
        handleFundingDetailsClick(seoId) {
            this.selectedFundingDetailVersion = this.devices.find(device => device.seoId === seoId);
            this.$nextTick(() => {
                this.showFundingPopin();
            });
        },
        handleRecoMobilesFundingDetailsClick(seoId) {
            // Les tuiles de reco peuvent référencer des déclinaisons de terminaux dont l'objet device n'a pas les prix.
            // On récupère donc directement le deviceSummary de la reco, qui contient toutes les infos de financement.
            this.selectedFundingDetailVersion = this.reco.mobiles.find(mobile => mobile.deviceSummary.seoId === seoId)?.deviceSummary;
            // On doit attendre le prochain cycle de rendu sinon l'affichage de la popin se fait trop rapidement
            // et la modification de `selectedFundingDetailVersion` n'a pas eu le temps de se "propager" dans le DOM.
            this.$nextTick(() => {
                this.showFundingPopin();
            });
        },
        showFundingPopin() {
            const popin = $("#funding-details-popin");
            if (popin) {
                popin.modal("show");
            }
        },
        handleEnergyLabelClick(seoId) {
            this.selectedEnergyLabel = this.devices.find(device => device.seoId === seoId)?.energyLabel;
            this.$nextTick(() => {
                this.showEnergyLabelPopin();
            });
        },
        handleRecoMobilesEnergyLabelClick(seoId) {
            // Les tuiles de reco référencent un terminal qui n'est pas toujours présent dans `devices`.
            // On récupère donc directement l'étiquette énergie depuis le deviceSummary de la reco.
            this.selectedEnergyLabel = this.reco.mobiles.find(mobile => mobile.deviceSummary.seoId === seoId)?.deviceSummary?.energyLabel;
            // On attend le prochain cycle de rendu pour laisser `selectedEnergyLabel` se propager dans le DOM
            // avant d'afficher la popin.
            this.$nextTick(() => {
                this.showEnergyLabelPopin();
            });
        },
        showEnergyLabelPopin() {
            const popin = $("#energy-label-popin");
            if (popin) {
                popin.modal("show");
            }
        },
        toggleFirstPartyOnly: function (fromChips = false) {
            this.firstPartyOnly = !this.firstPartyOnly;
            const brandLabel = this.brand === 'ORANGE' ? 'orange' : 'sosh';
            const actionLabel = fromChips
                ? `choix_filtre_vendu_par_${brandLabel}_supprime`
                : `choix_filtre_vendu_par_${brandLabel}_coche`;
            this.tmsLink(
                fromChips ? "resultats" : "filtre_commun",
                fromChips ? "oui" : this.firstPartyOnly ? "oui" : "non",
                actionLabel
            );
            this.scrollToHeaderTitle();
            this.filterDevices();
        },
        toggleBrand: function (brandId, isChecked, fromChips = false) {

            const updatedItems = [...this.brandCheckboxes];
            const itemIndex = updatedItems.findIndex(item => item.id === brandId);

            if (itemIndex !== -1) {
                updatedItems[itemIndex] = {
                    ...updatedItems[itemIndex],
                    isChecked: isChecked
                };

                //On coche Iphone en même temps si Apple est coché et vice-versa
                const toggledName = updatedItems[itemIndex].name;
                let linkedName = null;
                if (toggledName === "Apple") {
                    linkedName = "Iphone";
                } else if (toggledName === "Iphone") {
                    linkedName = "Apple";
                }

                if (linkedName) {
                    const linkedIndex = updatedItems.findIndex(item => item.name === linkedName);
                    if (linkedIndex !== -1 && !updatedItems[linkedIndex].disabled) {
                        updatedItems[linkedIndex] = {
                            ...updatedItems[linkedIndex],
                            isChecked: isChecked
                        };
                    }
                }

                this.brandCheckboxes = updatedItems;
                this.sendTmsLink(
                    updatedItems[itemIndex].name,
                    isChecked,
                    fromChips,
                    'marque'
                );
            }
            this.scrollToHeaderTitle();
            this.filterDevices();
        },
        togglePrice: function (priceId, isChecked, fromChips = false) {

            const updatedItems = [...this.priceCheckboxes];
            const itemIndex = updatedItems.findIndex(item => item.id === priceId);

            if (itemIndex !== -1) {
                updatedItems[itemIndex] = {
                    ...updatedItems[itemIndex],
                    isChecked: isChecked
                };

                this.priceCheckboxes = updatedItems;
                this.sendTmsLink(
                    updatedItems[itemIndex].name,
                    isChecked,
                    fromChips,
                    'prix'
                );
            }
            this.scrollToHeaderTitle();
            this.filterDevices();
        },
        toggleNote: function (noteId, isChecked, fromChips = false) {

            const updatedItems = [...this.noteCheckboxes];
            const itemIndex = updatedItems.findIndex(item => item.id === noteId);

            if (itemIndex !== -1) {
                updatedItems[itemIndex] = {
                    ...updatedItems[itemIndex],
                    isChecked: isChecked
                };

                this.noteCheckboxes = updatedItems;
                this.sendTmsLink(
                    updatedItems[itemIndex].name,
                    isChecked,
                    fromChips,
                    'avis_client'
                );
            }
            this.scrollToHeaderTitle();
            this.filterDevices();
        },
        toggleSelector: function (selectorId, isChecked, fromChips = false) {

            this.selectorGroupsCheckboxes = this.selectorGroupsCheckboxes.map(group => {
                const selectorIndex = group.selectors.findIndex(selector => selector.id === selectorId);
                if (selectorIndex === -1) return group;

                const updatedSelectors = [...group.selectors];
                updatedSelectors[selectorIndex] = {
                    ...updatedSelectors[selectorIndex],
                    isChecked: isChecked
                };

                return { ...group, selectors: updatedSelectors };
            });

            const group = this.selectorGroupsCheckboxes.find(group =>
                group.selectors.some(selector => selector.id === selectorId)
            );
            const selector = group?.selectors.find(selector => selector.id === selectorId);

            if (selector) {
                this.sendTmsLink(selector.name, isChecked, fromChips, 'selecteur');
            }

            const {editorialTitle, editorialDescription} = this.getEditorialFromSelectors(this.selectorGroupsCheckboxes);
            this.editorialTitle = editorialTitle;
            this.editorialDescription = editorialDescription;

            this.scrollToHeaderTitle();
            this.filterDevices();
        },
        toggleStatus: function (statusId, isChecked, fromChips = false) {
            const updatedItems = [...this.statusCheckboxes];
            const itemIndex = updatedItems.findIndex(item => item.id === statusId);
            if (itemIndex !== -1) {
                updatedItems[itemIndex] = {
                    ...updatedItems[itemIndex],
                    isChecked: isChecked
                };

                this.statusCheckboxes = updatedItems;
                this.sendTmsLink(
                    updatedItems[itemIndex].name,
                    isChecked,
                    fromChips,
                    'status'
                );
            }
            this.scrollToHeaderTitle();
            this.filterDevices();
        },
        toggleCompatibility: function (compatibilityId, isChecked, fromChips = false) {
            const updatedItems = [...this.compatibilityCheckboxes];
            const itemIndex = updatedItems.findIndex(item => item.id === compatibilityId);

            if (itemIndex !== -1) {
                updatedItems[itemIndex] = {
                    ...updatedItems[itemIndex],
                    isChecked: isChecked
                };

                this.compatibilityCheckboxes = updatedItems;
                this.sendTmsLink(
                    updatedItems[itemIndex].name,
                    isChecked,
                    fromChips,
                    'compatibility'
                );
            }
            this.scrollToHeaderTitle();
            this.filterDevices();
        },
        toggleBonusRanges: function (bonusId, isChecked, fromChips = false) {

            const updatedItems = [...this.bonusRangesCheckboxes];
            const itemIndex = updatedItems.findIndex(item => item.id === bonusId);

            if (itemIndex !== -1) {
                updatedItems[itemIndex] = {
                    ...updatedItems[itemIndex],
                    isChecked: isChecked
                };

                this.bonusRangesCheckboxes = updatedItems;
                this.sendTmsLink(
                    updatedItems[itemIndex].name,
                    isChecked,
                    fromChips,
                    'bonus'
                );
            }
            this.scrollToHeaderTitle();
            this.filterDevices();
        },
        updateBrandSearchValue: function (value) {
            this.brandSearchValue = value;
        },
        getMoreDevices: function () {
            this.showDeviceSpinner = true;
            this.fetchDevices(this.currentPage + 1).then(result => {
                this.currentPage = this.currentPage + 1;
                this.hasMoreDevices = result.hasMoreDevices;
                this.devices = this.devices.concat(result.devices);
                this.showDeviceSpinner = false;
                this.updateCurrentUrl();
            });
        },
        updateCurrentUrl: function () {
            let url = location.protocol + '//' + location.host + location.pathname;
            if (this.intentionParam === RENOUVELLEMENT_PARAM || this.intentionParam === PCM_PARAM || this.intentionParam === PCMOA_PARAM) {
                url = addParam(url, 'intention=' + CHANGER_DE_MOBILE_PARAM)
            } else {
                url = addParam(url, 'intention=' + this.intentionParam)
            }
            if (this.currentPage !== 1) url = addParam(url, pageParam + "=" + this.currentPage);
            if (this.sort && this.sort !== "par-defaut") {
                url = addParam(url, sortParam + "=" + this.sort);
            }

            if (this.firstPartyOnly) {
                url = addParam(url, (this.brand === 'ORANGE' ? orangeOnlyParam : soshOnlyParam) + '=true');
            }

            if (this.selectedBrands.length > 0) url = addParam(url, brandsParam + '=' + this.encodedSelectedBrandsParam);
            if (this.selectedPrices.length > 0) url = addParam(url, pricesParam + '=' + this.selectedPrices.join(','));
            if (this.selectedNotes.length > 0) url = addParam(url, notesParam + '=' + this.selectedNotes.join(','));
            if (this.selectedSelectors.length > 0) url = addParam(url, selectorsParam + '=' + this.selectedSelectors.join(','));
            if (this.segment) url = addParam(url, segmentParam + '=' + this.segment);
            if (this.disu !== null) url = addParam(url, 'disu=' + this.disu);

            if (this.selectedStatus.length > 0) url = addParam(url, statusParam + '=' + this.selectedStatus.join(','));

            if (this.selectedCompatibilities.length > 0) url = addParam(url, compatibilityParam + '=' + this.selectedCompatibilities.map((it) => encodeURIComponent(it)).join(','));

            if (this.selectedBonusRanges.length > 0) url = addParam(url, bonusRangesParam + '=' + this.selectedBonusRanges.join(','));

            // Propage les paramètres de la request d'origine non gérés par cette méthode.
            // Il est nécessaire de lister les paramètres à ne pas propager, en particulier lorsque les filtres sont supprimés
            const managedParams = [intentionParam, pageParam, sortParam, orangeOnlyParam, soshOnlyParam, brandsParam, pricesParam, notesParam, selectorsParam, segmentParam, disuParam, statusParam, compatibilityParam, bonusRangesParam];
            const originalParams = new URLSearchParams(window.location.search);
            const urlObj = new URL(url);
            originalParams.forEach(function (value, key) {
                if (!managedParams.includes(key) && !urlObj.searchParams.has(key)) {
                    url = addParam(url, key + '=' + value);
                }
            });

            window.history.replaceState({}, '', url);
        },
        updatePageUrlWithIntention() {
            if (this.intentionParam === RENOUVELLEMENT_PARAM || this.intentionParam === PCM_PARAM){
                return window.history.replaceState({}, null, updateUrlWithParam(window.location.href, "intention", CHANGER_DE_MOBILE_PARAM))
            }
            else return window.history.replaceState({}, null, updateUrlWithParam(window.location.href, "intention", this.intentionParam))
        },
        fetchDevices: function (page) {
            let url = this.apiRootUrl;
            let pageNumber = page < 1 ? 0 : page - 1; // l'API démarre les pages à 0
            url = addParam(url, 'page=' + pageNumber);
            if (this.sort && this.sort !== 'par-defaut') {
                url = addParam(url, 'sort=' + this.sort);
            }
            if (this.firstPartyOnly) {
                url = addParam(url, 'firstPartyOnly=true');
            }

            if (this.selectedBrands.length > 0) {
                url = addParam(url, 'brands=' + this.encodedSelectedBrandsParam);
            }
            if (this.selectedPrices.length > 0) {
                url = addParam(url, 'prices=' + this.selectedPrices.join(','));
            }
            if (this.selectedNotes.length > 0) {
                url = addParam(url, 'notes=' + this.selectedNotes.join(','));
            }
            if (this.selectedSelectors.length > 0) {
                url = addParam(url, 'selectors=' + this.selectedSelectors.join(','));
            } else if (this.segment) {
                url = addParam(url, 'selectors=' + this.segment);
            }
            url = addParam(url, 'department=' + this.currentDepartmentSeoId);

            url = addParam(url, 'brand=' + this.brand);
            url = addParam(url, 'intention=' + this.intentionParam);
            if (this.intentionParam === this.dto.selectedOffer?.intention) {
                url = addParam(url, 'offerSeoId=' + this.dto.selectedOffer.offerSeoId);
            }

            url = addParam(url, 'offerFromCart=' + this.offerFromCart);
            url = addParam(url, 'internetPartInCart=' + this.dto.hasInternetPartInCart);


            if (this.disu !== null) url = addParam(url, 'disu=' + this.disu);

            if (this.selectedStatus.length > 0) {
                url = addParam(url, 'status=' + this.selectedStatus.join(','));
            }

            if (this.selectedCompatibilities.length > 0) url = addParam(url, compatibilityParam + '=' + this.selectedCompatibilities.map((it) => encodeURIComponent(it)).join(','));

            if (this.selectedBonusRanges.length > 0) url = addParam(url, bonusRangesParam + '=' + this.selectedBonusRanges.join(','));

            if (this.intentionParam === RENOUVELLEMENT_PARAM || this.intentionParam === PCM_PARAM || this.intentionParam === PCMOA_PARAM) {
                url = addParam(url, 'clientContext=' + this.dto.clientContext);
            }

            // On demande la reco si on ne la pas déjà chargée et si on n'a pas de filtre
            let reco = false;
            if (this.hasNoFilters) {
                switch (this.intentionParam) {
                    case ACQUISITION_PARAM:
                        reco = this.recoForAcquisition == null;
                        break;
                    case PCM_PARAM:
                        reco = this.recoForPcm == null;
                        break;
                    case RENOUVELLEMENT_PARAM:
                        reco = this.recoForRenouvellement == null;
                        break;
                    case TSEUL_PARAM:
                        reco = this.recoForTSeul == null;
                        break;
                }
            }
            if (reco) {
                url = addParam(url, 'reco=' + reco);
            }

            return new Promise((resolve, reject) => {
                $.ajax({
                    method: "GET",
                    xhrFields: {
                        withCredentials: true
                    },
                    crossDomain: true,
                    url: url,
                    contentType: "application/json",
                    dataType: "json"
                }).done(result => {
                    resolve(result)
                }).fail(error => {
                    reject(error)
                    if (error.status !== 0) {
                        window.location.href = dto.infoViewUrl;
                    }
                });
            });
        },
        fetchFilters: function () {
            let url = this.apiRootUrl + "/filters";
            url = addParam(url, 'intention=' + this.intentionParam);
            url = addParam(url, 'brand=' + this.brand);

            if (this.firstPartyOnly) {
                url = addParam(url, 'firstPartyOnly=true');
            }

            if (this.selectedBrands.length > 0) {
                url = addParam(url, 'brands=' + this.encodedSelectedBrandsParam);
            }
            if (this.selectedPrices.length > 0) {
                url = addParam(url, 'prices=' + this.selectedPrices.join(','));
            }
            if (this.selectedNotes.length > 0) {
                url = addParam(url, 'notes=' + this.selectedNotes.join(','));
            }
            if (this.selectedSelectors.length > 0) {
                url = addParam(url, 'selectors=' + this.selectedSelectors.join(','));
            } else if (this.segment) {
                url = addParam(url, 'selectors=' + this.segment);
            }
            url = addParam(url, 'department=' + this.currentDepartmentSeoId);

            if (this.intentionParam === this.dto.selectedOffer?.intention) {
                url = addParam(url, 'priceKey=' + this.dto.selectedOffer.devicePriceKey);
            }
            url = addParam(url, 'internetPartInCart=' + this.dto.hasInternetPartInCart);

            if (this.intentionParam === RENOUVELLEMENT_PARAM || this.intentionParam === PCM_PARAM || this.intentionParam === PCMOA_PARAM) {
                url = addParam(url, 'clientContext=' + this.dto.clientContext);
            }

            if (this.disu !== null) url = addParam(url, 'disu=' + this.disu);

            if (this.selectedStatus.length > 0) {
                url = addParam(url, 'status=' + this.selectedStatus.join(','));
            }

            if (this.selectedCompatibilities.length > 0) url = addParam(url, compatibilityParam + '=' + this.selectedCompatibilities.map((it) => encodeURIComponent(it)).join(','));

            if (this.selectedBonusRanges.length > 0) url = addParam(url, bonusRangesParam + '=' + this.selectedBonusRanges.join(','));

            return new Promise((resolve, reject) => {
                $.ajax({
                    method: "GET",
                    xhrFields: {
                        withCredentials: true
                    },
                    crossDomain: true,
                    url: url,
                    contentType: "application/json",
                    dataType: "json"
                }).done(result => {
                    resolve(result)
                }).fail(error => {
                    reject(error)
                    if (error.status !== 0) {
                        window.location.href = dto.infoViewUrl;
                    }
                });
            });
        },
        sortDevices: function (sort) {
            Tms.link({category: "selecteur_produit", action: sort.id, label: "tri"});
            this.sort = sort.id;
            this.filterDevices();
        },
        filterDevices: function () {
            this.devices = [];
            this.currentPage = 1;
            this.showDeviceSpinner = true;
            this.fetchFilters().then(result => {
                const normalizedSelected = this.normalizeBrands(this.selectedBrands, this.getBrandCheckboxes(result, this.selectedBrands));
                this.brandCheckboxes = this.getBrandCheckboxes(result, normalizedSelected);
                this.priceCheckboxes = this.getPriceCheckboxes(result, this.selectedPrices);
                this.noteCheckboxes = this.getNoteCheckboxes(result, this.selectedNotes);
                this.selectorGroupsCheckboxes = this.getSelectorGroupsCheckboxes(result, this.dto.segmentSeoId, this.selectedSelectors);
                this.statusCheckboxes = this.getStatusCheckboxes(result, this.selectedStatus);
                this.compatibilityCheckboxes = this.getCompatibilityCheckboxes(result, this.selectedCompatibilities);
                this.bonusRangesCheckboxes = this.getBonusRangesCheckboxes(result, this.selectedBonusRanges);
                this.updateCurrentUrl();
                this.fetchDevices(this.currentPage).then(result => {
                    this.devices = result.devices;
                    this.updateReco(result.reco);
                    this.numberOfResults = result.numberOfResults ?? null;
                    this.hasMoreDevices = result.hasMoreDevices;
                    this.showDeviceSpinner = false;
                    this.filtersAndSortAccessibleLabel = this.getFiltersAndSortLabel();
                    this.pxfEnabled = result.pxfEnabled;
                    this.cb4xEnabled = result.cb4xEnabled;
                    this.headerTitle = result.headerTitle;
                });
            });
        },
        updateReco: function (reco) {
            if (reco) {
                switch (this.intentionParam) {
                    case ACQUISITION_PARAM:
                        this.recoForAcquisition = reco;
                        break;
                    case PCM_PARAM:
                        this.recoForPcm = reco;
                        break;
                    case RENOUVELLEMENT_PARAM:
                        this.recoForRenouvellement = reco;
                        break;
                    case TSEUL_PARAM:
                        this.recoForTSeul = reco;
                        break;
                }
            }
        },
        onDeleteSelectionClick: function () {
            this.tmsLink(
                "resultats",
                "tout_effacer",
                "choix_filtre_supprime"
            );
            this.deleteAllFilters();
            this.filterDevices();
        },
        deleteAllFilters: function () {
            this.orangeOnly = false;
            this.brandCheckboxes = this.brandCheckboxes.map(checkbox => {
                return {
                    ...checkbox,
                    isChecked: false
                }
            });
            this.priceCheckboxes = this.priceCheckboxes.map(checkbox => {
                return {
                    ...checkbox,
                    isChecked: false
                }
            });
            this.noteCheckboxes = this.noteCheckboxes.map(checkbox => {
                return {
                    ...checkbox,
                    isChecked: false
                }
            });
            this.selectorGroupsCheckboxes = this.selectorGroupsCheckboxes.map(group => ({
                ...group,
                selectors: group.selectors.map(selector => ({ ...selector, isChecked: false }))
            }));
            this.statusCheckboxes = this.statusCheckboxes.map(checkbox => {
                return {
                    ...checkbox,
                    isChecked: false
                }
            });
            this.compatibilityCheckboxes = this.compatibilityCheckboxes.map(checkbox => {
                return {
                    ...checkbox,
                    isChecked: false
                }
            });
            this.bonusRangesCheckboxes = this.bonusRangesCheckboxes.map(checkbox => {
                return {
                    ...checkbox,
                    isChecked: false
                }
            });
            this.brandSearchValue = '';
            this.editorialTitle = null;
            this.editorialDescription = null;
        },
        updateLayout() {
            //nombre de tuiles par ligne selon le media (mobile, tablette et desktop)
            let nbOfTilesPerRow = 1
            if (window.matchMedia("(min-width: " + myshop.ob1.breakpoints.xxl + "px)").matches) {
                nbOfTilesPerRow = 3
            } else if (window.matchMedia("(min-width: " + myshop.ob1.breakpoints.md + "px)").matches) {
                nbOfTilesPerRow = 2
            }

            this.alignCardItemsVertically(".selector-accessory-card .mobile-infos", nbOfTilesPerRow);
            this.alignCardItemsVertically(".selector-accessory-card .infos-price", nbOfTilesPerRow);
            this.alignCardItemsVertically(".selector-accessory-card .infos-advantage", nbOfTilesPerRow);
            this.alignCardItemsVertically(".selector-accessory-card .infos-cart", nbOfTilesPerRow);
            this.alignCardItemsVertically(".selector-accessory-card .infos-seller", nbOfTilesPerRow);
            this.alignCardItemsVertically(".selector-accessory-card .payment-solutions-details", nbOfTilesPerRow);
        },
        alignCardItemsVertically(selector, nbOfTilesPerRow) {
            let listElements = document.querySelectorAll(selector);
            if (listElements.length > 0) {
                for (let row = 0; row < listElements.length; row += nbOfTilesPerRow) {
                    let tmp = [];
                    tmp.push(Array.from(listElements).slice(row, row + nbOfTilesPerRow));
                    let elements = tmp.flat()
                    if (elements.length > 0) {
                        this.alignItemsVertically(elements, nbOfTilesPerRow)
                    }
                }
            }
        },
        getMaximumHeight(list) {
            const heights = Array.from(list)
                .filter(elt => !$(elt).is(".navads"))
                .map(elt => $(elt).height());
            return Math.max(...heights);
        },
        alignItemsVertically(list, nbOfTilesPerRow) {
            Array.from(list).forEach(elt => {
                elt.style.removeProperty("height")
            });
            //Pas de mise à jour de hauteur de ligne pour media mobile
            if (nbOfTilesPerRow > 1) {
                const maxHeight = this.getMaximumHeight(list);
                if (maxHeight === 0) {
                    return;
                }
                Array.from(list).forEach(elt => {
                    if (!$(elt).is(".navads")) {
                        $(elt).height(maxHeight)
                    }
                });
            }
        },
        getBrandCheckboxes(filters, selectedBrands) {
            return filters.brands.map((brand, index) => {
                let isChecked = selectedBrands.some(b => b.toLowerCase() === brand.value.toLowerCase())

                return {
                    id: 'brand-' + index,
                    name: brand.label,
                    disabled: brand.count === 0 && !isChecked,
                    label: brand.label + ' (' + brand.count + ')',
                    accessibleLabel: brand.label + ', ' + brand.count + ' produits',
                    isChecked: isChecked,
                    dataTestId: 'brand-' + index
                }
            })
        },
        getPriceCheckboxes(filters, selectedPrices) {
            return filters.prices.map((price, index) => {
                let isChecked = selectedPrices.includes(price.value);
                let label = price.count != null ? price.label + ' (' + price.count + ')' : price.label
                let accessibleLabel = price.count != null ? price.label + ', ' + price.count + ' produits' :  price.label
                return {
                    id: 'price-' + index,
                    value: price.value,
                    name: price.label,
                    disabled: price.count === 0 && !isChecked,
                    label: label,
                    accessibleLabel: accessibleLabel,
                    isChecked: isChecked,
                    dataTestId: 'price-' + index
                }
            })
        },
        getNoteCheckboxes(filters, selectedNotes) {
            return filters.notes.map((note, index) => {
                let isChecked = selectedNotes.includes(note.value);
                let label = note.count != null ? note.label + ' (' + note.count + ')' : note.label
                let accessibleLabel = note.count != null ? note.label + ', ' + note.count + ' produits' : note.label
                return {
                    id: 'note-' + index,
                    value: note.value,
                    name: note.label,
                    count: note.count,
                    disabled: note.count === 0 && !isChecked,
                    label: label,
                    accessibleLabel: accessibleLabel,
                    isChecked: isChecked,
                    dataTestId: 'note-' + index
                }
            })
        },
        getSelectorGroupsCheckboxes(filters, segment, selectedSelectors) {
            if (segment) return [];
            else return filters.selectorGroups.map((selectorGroup, indexGroup) => {
                return {
                    id: 'selectorGroup-' + indexGroup,
                    label: selectorGroup.label,
                    selectors : selectorGroup.selectors.map((selector, index) => {
                        let isChecked = selectedSelectors.includes(selector.value);
                        return {
                            id: 'selector-' + indexGroup + '-' + index,
                            value: selector.value,
                            name: selector.label,
                            count: selector.count,
                            disabled: false,
                            label: selector.label,
                            accessibleLabel: selector.label,
                            isChecked: isChecked,
                            dataTestId: 'selector-' + indexGroup + '-' + index,
                            editorialTitle: selector.editorialTitle,
                            editorialDescription: selector.editorialDescription
                        }
                    })
                }
            })
        },
        getStatusCheckboxes(filters, selectedStatus) {
            return filters.status.map((status, index) => {
                let isChecked = selectedStatus.some(b => b.toLowerCase() === status.value)

                return {
                    id: 'status-' + index,
                    name: status.label,
                    value: status.value,
                    disabled: false,
                    label: status.label,
                    accessibleLabel: status.label,
                    isChecked: isChecked,
                    dataTestId: 'status-' + index
                }
            })
        },
        getCompatibilityCheckboxes(filters, selectedCompatibility) {
            return filters.compatibilities.map((compatibility, index) => {
                let isChecked = selectedCompatibility.some(b => b.toLowerCase() === compatibility.value.toLowerCase())

                return {
                    id: 'compatibility-' + index,
                    name: compatibility.label,
                    value: compatibility.value,
                    disabled: false,
                    label: compatibility.label,
                    accessibleLabel: compatibility.label,
                    isChecked: isChecked,
                    dataTestId: 'compatibility-' + index
                }
            })
        },
        getBonusRangesCheckboxes(filters, selectedBonusRanges) {
            return filters.bonusRanges.map((bonus, index) => {
                let isChecked = selectedBonusRanges.includes(bonus.value);
                return {
                    id: 'bonus-' + index,
                    value: bonus.value,
                    name: bonus.label,
                    disabled:false,
                    label: bonus.label,
                    accessibleLabel: bonus.label,
                    isChecked: isChecked,
                    dataTestId: 'bonus-' + index
                }
            })
        },
        getFiltersAndSortLabel() {
            //Méthode volontairement non computed pour contrôler à quel moment a lieu la vocalisation
            let selectedSort = this.dto.dropDownDto.items.find(sort => sort.id === this.sort)

            let label = "";
            label += "Nous avons trouvé ";
            if (this.numberOfResults != null) label += this.resultsLabel; else label += "les résultats";
            if (this.numberOfSelectedFilters > 0) label += " avec les filtres "
            if (this.firstPartyOnly) label += this.brand === 'ORANGE' ? " vendu par Orange," : " vendu par Sosh,"
            if (this.selectedSelectors.length > 0) label += " sélecteur " + this.selectedSelectorsCheckboxes.map(checkBox => checkBox.name).join(', ') + ","
            if (this.selectedBrands.length > 0) label += " marque " + this.selectedBrands.join(', ') + ","
            if (this.selectedPrices.length > 0) label += " prix " + this.selectedPricesCheckboxes.map(checkBox => checkBox.name).join(', ') + ","
            if (this.selectedNotes.length > 0) label += " notes " + this.selectedNotesCheckboxes.map(checkBox => checkBox.name).join(', ') + ","
            if (this.selectedStatus.length > 0) label += " état " + this.selectedStatusCheckboxes.map(checkBox => checkBox.name).join(', ') + ","
            if (this.selectedCompatibilities.length > 0) label += " compatibilité " + this.selectedCompatibilityCheckboxes.map(checkBox => checkBox.name).join(', ') + ","
            if (this.selectedBonusRanges.length > 0) label += " bonus " + this.selectedBonusRangesCheckboxes.map(checkBox => checkBox.name).join(', ') + ","
            if (selectedSort) label += " triés " + selectedSort.label;

            return label;
        },
        switchIntention(selectedId) {

            if (this.dto.customerPopin && selectedId === "intention-changer-de-mobile") {
                $('#customer-popin-id').modal('show')
            } else if (this.brand === "ORANGE" && selectedId === "intention-changer-de-mobile") {
                // On fait un reload de la page pour gérer les page d'erreur sur l'eligibilité au changement de mobile
                window.location.href = updateUrlWithParam(window.location.href, "intention", CHANGER_DE_MOBILE_PARAM);
            } else {
                if (selectedId === "intention-tseul") {
                    this.intentionParam = TSEUL_PARAM;
                } else if (selectedId === "intention-acquisition") {
                    this.intentionParam = ACQUISITION_PARAM;
                } else if (selectedId === "intention-changer-de-mobile") {
                    // On est sur sosh : on force l'intention renouvellement
                    this.intentionParam = RENOUVELLEMENT_PARAM;
                }
                this.filterDevices();

                this.updatePageUrlWithIntention();
                this.updateTmsData();
            }
        },
        updateTmsData() {
            if (!window.o_utagview || !tmsData) return;
            if ((this.brand === "SOSH" && this.intentionParam === RENOUVELLEMENT_PARAM) || this.intentionParam === TSEUL_PARAM) {
                tmsData.contexte_produit = "acquisition_terminal_seul"
            } else if (this.intentionParam === ACQUISITION_PARAM) {
                tmsData.contexte_produit = "acquisition_terminal_vers_forfait"
            } else if (this.intentionParam === PCM_PARAM) {
                tmsData.contexte_produit = "changement_pcm"
            } else if (this.intentionParam === RENOUVELLEMENT_PARAM) {
                tmsData.contexte_produit = "changement_renouvellement"
            }
            Tms.view(tmsData)
        },
        handleBreakpointChange(e) {
            this.isMobile = e.matches;
            this.moveFiltersToTarget();
        },
        moveFiltersToTarget() {
            const filtersEl = this.$refs.filtersWrapper;
            const target = this.isMobile
                ? this.$refs.filtersMobileTarget
                : this.$refs.filtersDesktopTarget;

            if (filtersEl && target) {
                target.appendChild(filtersEl);
            }
        },
        skipFilters(){
            this.$nextTick(() => {
                const firstFocusable = this.$el.querySelector('#productsList a');
                if (firstFocusable) firstFocusable.focus();
            });
        },
        goToFilters(){
            this.$nextTick(() => {
                const firstFocusable = this.$el.querySelector('#device-list-filters a, #device-list-filters button, #device-list-filters [tabindex]:not([tabindex="-1"])');
                if (firstFocusable) firstFocusable.focus();
            });
        },
        updateRefurbishmentAnimationUrl(url) {
            const intention = new URLSearchParams(window.location.search).get('intention');
            const updatedUrl = new URL(url, window.location.origin);
            if (intention) {
                updatedUrl.searchParams.set('intention', intention);
            }
            this.refurbishmentAnimationUrl = updatedUrl.toString();
        },
        sendTmsLink(itemName, isChecked, fromChips, type) {
            const actionLabel = fromChips
                ? `choix_filtre_${type}_supprime`
                : isChecked
                    ? `choix_filtre_${type}_coche`
                    : `choix_filtre_${type}_decoche`;

            this.tmsLink(
                fromChips ? "resultats" : "filtre_commun",
                toTmsFormat(itemName),
                actionLabel
            );
        },
        tmsLink(category, action, label) {
            Tms.link({
                category: category,
                action: action,
                label: label
            });
        },
        normalizeBrands(brands, brandCheckboxes) {
            return syncAppleIphone(brands, brandCheckboxes);
        },
        scrollToHeaderTitle() {
            const element = document.getElementById("header-title");
            if (element) {
                scrollToElement(element, {dx: 0, dy: -element.offsetHeight});
            }
        },
        getEditorialFromSelectors(selectorGroupsCheckboxes) {
            const checkedSelectors = selectorGroupsCheckboxes
                .flatMap(group => group.selectors)
                .filter(selector => selector.isChecked);
            //On prend le titre et la description du premier sélecteur coché si un seul est coché, sinon on ne prend rien
            const selector = checkedSelectors.length === 1 ? checkedSelectors[0] : null;
            return {
                editorialTitle: selector?.editorialTitle ?? null,
                editorialDescription: selector?.editorialDescription ?? null
            };
        }
    }
};
</script>

<style scoped lang="scss">
@import 'ob1_common';
@import 'ob1_variables';

.energy-label-padding {
    padding: .4375rem 0 .625rem;
}

@media (max-width: #{map-get($grid-breakpoints, xl)}) {
    .chips-filters {
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none; /* IE/Edge */
        .ob1-inputchip {
            flex-shrink: 0; // Empêche la compression des chips
        }
    }
}

@media (max-width: #{map-get($grid-breakpoints, xl)}) {
    .padding-button{
        padding: 5px 0 2px 0;
    }
}

.flex-basis-0 {
    flex-basis: 0 !important;
}

@media (min-width: #{map-get($grid-breakpoints, xxl)}) {
    .filters-sidebar {
        flex: 0 0 22%;
        max-width: 22%;
    }

    .main-content-sidebar {
        flex: 0 0 78%;
        max-width: 78%;
    }
}

@media (min-width: #{map-get($grid-breakpoints, xl)}) and (max-width: #{map-get($grid-breakpoints, xxl) - 1}) {
    .filters-sidebar {
        flex: 0 0 27%;
        max-width: 27%;
    }

    .main-content-sidebar {
        flex: 0 0 73%;
        max-width: 73%;
    }
}

@media (min-width: #{map-get($grid-breakpoints, md)}) {
    .border-bottom-md-none {
        border-bottom: none !important;
    }
    .border-end-md-none {
        border-right: none !important;
    }
}

.breadcrumb-full ::v-deep .breadcrumb {
    max-width: 100%;
}

</style>
